import Table from './Table';
import './table.scss';

export default Table;